import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Col, H5, P, Row} from '@modifi/ui'

import {Wrapper, FormWrapper} from './styles'

const propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  backgroundColor: PropTypes.string,
}

const defaultProps = {
  headline: '',
  description: '',
  backgroundColor: undefined,
}

export type SignupFormComponentWrapperProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const SignupFormComponentWrapper: React.FC<SignupFormComponentWrapperProps> = ({
  headline,
  description,
  children,
  backgroundColor,
}) => (
  <Wrapper backgroundColor={backgroundColor}>
    <Row>
      <Col lg={6}>
        <H5>{headline}</H5>
        <P>{description}</P>
      </Col>
      <Col lg={6}>
        <FormWrapper>{children}</FormWrapper>
      </Col>
    </Row>
  </Wrapper>
)

SignupFormComponentWrapper.propTypes = propTypes

SignupFormComponentWrapper.defaultProps = defaultProps

export default SignupFormComponentWrapper
